/**
 * @creator Stefano
 * @date 26-6-2018
 */
import DataCollector from "./DataCollector";
import Utils from "../utils/Utils";

export default class DataHelper extends DataCollector {
    constructor() {
        super();
        this._ordered_spreads = [];
        this._issue_data = {};
        this._moveDomRotate = {};
        this._urlList = {};
        this.inline_spreads = [];
        this._skippedSpreads = [];
        this._main_spread_ids = null;
        this._MainNavigationIssue = {};
        this._close_button = [];
    }

    /**
     * Set the correct spread url that will be rendered into the navigation menu's of the interfaces
     * @param spreads
     * @returns {*}
     */
    setSpreadUrl(spreads) {
        for (let index in spreads) {
            if (spreads[index].url !== undefined) {
                return spreads;
            }
            let spread_name = Utils.urlEncodeString(spreads[index]["spread_title"]); //replace the %20 with a underscore
            spreads[index].url = spreads[index].spread_id + "/" + spread_name + ".html";
            if (!Utils.isEmpty(spreads[index].url)) {
                this.createUrlList(spreads[index]);
            }
        }
        return spreads;
    }

    getUrlList() {
        return this._urlList;
    }

    createUrlList(spread) {
        this._urlList[spread.url] = {
            spread_id: parseInt(spread.spread_id),
            issue_id: parseInt(spread.js_issue_issue_id),
            language: this.getLanguageAbbr(this.issues[spread.js_issue_issue_id].cl_language_language_id),
        };
    }

    searchForUrl(spread_id) {
        let list = Object.entries(this.getUrlList());
        for (let [url, spread] of list) {
            if (spread_id === spread.spread_id) {
                return url;
            }
        }
        return false;
    }

    /**
     * Online magazines legacy issues only if enabled by admins
     * @returns {Array}
     */
    getLegacyIssues() {
        let array_issues = [];
        for (let issue_id in this.legacy_issues) {
            if (this.legacy_issues[issue_id].cl_language_language_id == this._cl_language_language_id) {
                let spreads = this.legacy_issues[issue_id].js_spreads || this.legacy_issues[issue_id].spreads;
                this.legacy_issues[issue_id].spread = spreads[0];
                array_issues.push(this.legacy_issues[issue_id]);
            }
        }

        //sort the issues
        return array_issues.sort((a, b) => Math.sign(parseInt(a.issue_id, 10) - parseInt(b.issue_id, 10)));
    }

    /**
     * try to find the category by name if not found it will result into undefined
     * @param category_name
     * @return object | undefined
     */
    getCategoryByName(category_name) {
        return (
            window.categories &&
            window.categories.find(
                (cat) => cat.name_lower === category_name || escape(cat.name_lower) === category_name,
            )
        );
    }

    /**
     * overwrite the spreads list with all the active spreads and order the spread to the correct join_ranking
     * Also add page index for the correct page index of the spreads list
     *
     */
    filterIssues(category_filter, publication_type) {
        let old_issues = this.issues;
        let new_issues = [],
            id;

        //if we have no category filter set then render with all the correct issues
        if (!category_filter) {
            category_filter = this._getDefaultCategory();
            if (category_filter === false && window.categories.length != 0) {
                this._filtered_issues = [];
                for (id in old_issues) {
                    if (old_issues[id].cl_publication_type_publication_type_id == publication_type) {
                        if (this._cl_language_language_id != undefined) {
                            if (this._cl_language_language_id == old_issues[id].cl_language_language_id) {
                                new_issues.push(old_issues[id]);
                                this._filtered_issues = new_issues;
                            }
                        } else {
                            new_issues.push(old_issues[id]);
                            this._filtered_issues = new_issues;
                        }
                    }
                }
            } else {
                let remove_cat_ids = [];
                for (id in old_issues) {
                    if (old_issues[id].cl_publication_type_publication_type_id == publication_type) {
                        if (window.cat_filter != "undefined") {
                            if (
                                window.cat_filter[category_filter].indexOf(old_issues[id].issue_id) > -1 ||
                                window.cat_filter[category_filter].indexOf(parseInt(old_issues[id].issue_id)) > -1
                            ) {
                                if (this._cl_language_language_id != undefined) {
                                    if (this._cl_language_language_id == old_issues[id].cl_language_language_id) {
                                        new_issues.push(old_issues[id]);
                                    } else {
                                        remove_cat_ids.push(old_issues[id].issue_id); //todo remove categories
                                        //let index = cat_filter[category_filter].indexOf(parseInt(old_issues[id].issue_id));
                                        //delete(cat_filter[category_filter][index]);
                                    }
                                } else {
                                    new_issues.push(old_issues[id]);
                                }
                            }
                        }
                    }
                }
                this._filtered_issues = new_issues;
            }
        }
        //if we have a category filter set then filter the issues on category_id
        else if (window.cat_filter != "undefined") {
            let list_issues = window.cat_filter;

            if (list_issues[category_filter] == undefined) {
                console.warn("category not available anymore!");
                return;
            }

            //create a list with all the active spreads
            for (id in old_issues) {
                if (
                    list_issues[category_filter].indexOf(old_issues[id].issue_id) > -1 ||
                    list_issues[category_filter].indexOf(parseInt(old_issues[id].issue_id, 10)) > -1
                ) {
                    if (this._cl_language_language_id != undefined) {
                        if (this._cl_language_language_id == old_issues[id].cl_language_language_id) {
                            new_issues.push(old_issues[id]);
                        }
                    } else {
                        new_issues.push(old_issues[id]);
                    }
                }
            }
            this._filtered_issues = new_issues; //all active spreads order by join_ranking
        }

        this._orderingIssues();
        return this._filtered_issues;
    }

    /**
     * first order them by date_created
     * then order them by date_ranking
     * @private
     */
    _orderingIssues() {
        try {
            if (this._filtered_issues[0] == undefined) {
                console.warn("No issues!");
                this._filtered_issues = [];
                return;
            }
            if (Object.hasOwn(this._filtered_issues[0], "date_created")) {
                this._filtered_issues = this._filtered_issues.sort((d1, d2) => {
                    let date1 = d1.date_created,
                        date2 = d2.date_created;
                    if (typeof date1 === "string") {
                        date1 = Date.parse(date1.replace(/-/g, "/"));
                        date2 = Date.parse(date2.replace(/-/g, "/"));
                    }
                    return date2 - date1;
                });
            }

            this._filtered_issues = this._filtered_issues.sort(this.dateRankingOrder.bind(this));
        } catch (error) {
            console.error("MAGLR ERROR: [orderingIssues]", error);
        }
    }

    /**
     * Get the default category id by the name Default
     * @returns {*}, boolean
     * @private
     */
    _getDefaultCategory() {
        let cat_id;
        if (window.categories != undefined) {
            for (let i in window.categories) {
                if (window.categories[i].default_status == 1) {
                    cat_id = window.categories[i].category_id;
                    return cat_id;
                }
            }
        }
        return false;
    }

    /**
     * Get the first category in the categories list that is not a default category
     *
     * @returns {Object||bool}
     */
    getFirstCategory() {
        return window.categories && window.categories.find((cat) => cat.render);
    }

    /**
     *
     * sets language id into memory by give abbreviation
     * @param language
     *
     */
    getLanguageAbbr(language_id) {
        if (window.client_languages) {
            for (let i in window.client_languages) {
                if (window.client_languages[i]["language_id"] == language_id) {
                    return window.client_languages[i]["abbreviation"];
                }
            }
        }
    }
    /**
     *
     * sets language id into memory by give abbreviation
     * @param language
     *
     */
    getLanguageId(language) {
        if (self.client_languages) {
            for (let i in window.client_languages) {
                if (window.client_languages[i]["abbreviation"] == language) {
                    this._cl_language_language_id = window.client_languages[i]["language_id"];
                    break;
                }
            }
        }
    }

    /**
     * Check if we have spread_ids that may be skipped
     * @param spread_id
     * @return {boolean}
     */
    isSkippedSpread(search) {
        return this._skippedSpreads.find((skipped) => skipped.spread_id === search || skipped.url === search);
    }

    /**
     * filter the issues cover spread because the api doesn't return the correct final issue cover
     * @param issues
     * @returns {*}
     */
    prepareIssuesForRender(issues) {
        for (let id in issues) {
            let spreads = this.filterAndOrderSpreads(issues[id].issue_id);
            if (spreads.length > 0) {
                if (window.exportType === "ipad") {
                    issues[id].cover = "large.jpg";
                } else {
                    issues[id].cover = spreads[0].spread_id;
                }
                if (!Utils.isEmpty(issues[id].date_published)) {
                    if (typeof issues[id].date_published === "string") {
                        issues[id].timestamp = new Date(issues[id].date_published.replace(/-/g, "/")).getTime();
                    } else {
                        issues[id].timestamp = issues[id].date_published;
                    }
                    issues[id].overviewDate = new Date(issues[id].timestamp * 1000).toLocaleDateString();
                }

                this.setSpreadUrl(spreads);

                issues[id].url = `/${spreads[0].url}`;
            }
        }
        return issues;
    }

    getCurrentIssue() {
        return this.getIssueByIssueId(window.frontend.getCurrentIssueId());
    }

    getCurrentSpread() {
        return this.getSpreadById(window.frontend.getCurrentIssueId(), window.frontend.getCurrentSpreadId());
    }

    getCurrentSpreads() {
        return this._getSpreadsByIssueId(window.frontend.getCurrentIssueId());
    }
    /**
     * get spread based on issue_id & spread_id
     * @param issue_id
     * @param spread_id
     * @return {undefined}
     */
    getSpreadById(issue_id, spread_id) {
        const { spread } = this.getIssueAndSpreadById(issue_id, spread_id);
        return spread;
    }

    getIssueAndSpreadById(issueId, spreadId) {
        const issue = this.issues[issueId];
        if (issue) {
            let spreads = issue.js_spreads || issue.spreads;
            const spread = spreads.find((spread) => spread.spread_id === spreadId);
            return { issue, spread };
        }
        return {};
    }

    /**
     * Return the first spread_id based on issue_id
     * @param {Number} issue_id
     * @return {mixed} boolean or int
     */
    getFirstSpreadId(issueId) {
        const firstSpread = this.getFirstSpread(issueId);
        return (firstSpread && firstSpread?.spread_id) || false;
    }

    /**
     * Get the first available spread for the given issue
     */
    getFirstSpread(issueId) {
        return this._ordered_spreads?.[issueId][0] || false;
    }

    /**
     *
     * @param issue_id
     * @param reference
     * @return {*}
     * @private
     */
    _resolveReferenceTag(issue_id, reference) {
        if (reference && reference != "") {
            // validate the given value
            for (let i = 0; i < this._ordered_spreads[issue_id].length; i++) {
                if (this._ordered_spreads[issue_id][i].reference_tag == reference) {
                    return this._ordered_spreads[issue_id][i].spread_id;
                }
            }
        }
        console.warn("Reference (" + reference + ") not valid or not found in current issue.");
        return false;
    }

    /**
     * @private
     * @param issue_id
     * @return {Map}
     */
    getIssueByIssueId(issue_id) {
        if (this.issues[issue_id]) {
            return this.issues[issue_id];
        }
        for (let i in this.issues) {
            if (this.issues[i].issue_id == issue_id) {
                return this.issues[i];
            }
        }
    }

    /**
     * @private
     * @param issue_id
     * @return {Map}
     */
    _getSpreadsByIssueId(issue_id) {
        const issue = this.getIssueByIssueId(issue_id);
        return issue.js_spreads || issue.spreads;
    }

    /**
     * Order the issues on joinRanking
     * @param array
     * @returns {*}
     */
    orderByJoinRanking(array) {
        //sort the spreads
        array.sort((a, b) => {
            let keyA = parseInt(a.join_ranking);
            let keyB = parseInt(b.join_ranking);

            // Compare the 2 rankings
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
        return array;
    }
    checkIfDateNullOrNaN(date) {
        if (date == null) {
            return 1;
        }
        if (typeof date === "string") {
            date = Date.parse(date.replace(/-/g, "/"));
            if (isNaN(date)) {
                return 1;
            }
        }
        return date;
    }

    dateRankingOrder(date1, date2) {
        let t1 = this.checkIfDateNullOrNaN(date1.date_ranking);
        let t2 = this.checkIfDateNullOrNaN(date2.date_ranking);
        if (t1 > t2) return -1;
        if (t1 < t2) return 1;
        return 0;
    }

    getSpreadJsVersion(spread_id) {
        return this._spreads_versions[spread_id];
    }

    /**
     * concat spreads into memory of issue_id that is used
     * @param issue_id
     * @param spreads_list
     * @return {Array}
     */
    getSpreadIdListOrder(issue_id, spreads_list) {
        let spreads = this.filterAndOrderSpreads(issue_id, spreads_list);
        this._spreads = [];
        this._spreads_versions = {};
        for (let i in spreads) {
            let spread_id = +spreads[i].spread_id;
            this._spreads_versions[spread_id] = +spreads[i].assets_version_js;
            if (window.previewMode) {
                this._spreads_versions[spread_id] = +spreads[i].assets_version_preview || +spreads[i].assets_version_js;
            }
            this._spreads.push(spread_id);
        }
        return this._spreads;
    }

    /**
     * Checks if main_spreads are parse if not so we parse and give back if the issue has issue type level(horizontal navigation)
     * @param issue_id
     * @returns {*}
     */
    hasMainSpreadNavigation(issue_id) {
        if (this._main_spread_ids === null || this._MainNavigationIssue[issue_id] === undefined) {
            this.createMainSpreadNavigationList(issue_id);
            this._MainNavigationIssue[issue_id] = !!this._main_spread_ids;
        }
        return this._MainNavigationIssue[issue_id];
    }

    /**
     * Check if the given spread_id is main spread or not
     * @param issue_id
     * @param spread_id
     * @returns {boolean}
     */
    isMainSpread(issue_id, spread_id) {
        if (!this.hasMainSpreadNavigation(issue_id)) {
            return true;
        } else {
            if (this._issue_data[issue_id].length === 0) {
                //failsafe for when issue_data has no mainSpreads because of an data error.
                return true;
            }
            // return !!this._issue_data[issue_id].find(spread => parseInt(spread.id,10) === spread_id);
            return this._main_spread_ids.indexOf(spread_id) > -1;
        }
    }

    /**
     * This will parse the issue_data and store in memory with the correct levels of main spread and sub navigation
     * of spread
     * WARNING the issue_data given is not the same because we flatten the array if type linear is given!
     * @param issue_id
     * @returns {*}
     */
    createMainSpreadNavigationList(issue_id) {
        try {
            if (!this._issue_data[issue_id]) {
                let issue = this.getIssueByIssueId(issue_id);
                let issue_data = JSON.parse(issue.issue_data);

                const activeSpreadIds = this._getSpreadsByIssueId(issue_id).map((s) => s.spread_id);

                //filter inactive main spreads
                issue_data = issue_data
                    .map((spread) => {
                        let spreadId = parseInt(spread.id, 10);
                        if (activeSpreadIds.indexOf(spreadId) > -1) {
                            return spread;
                        }
                    })
                    .filter(Boolean);

                this._issue_data[issue_id] = issue_data;
            }
            var hasSubNavigation = false;
            this._close_button = [];
            //Fetch all main spread include type=linear which means the are main spreads
            //flat(2) will put the children spread_ids into the main list
            this._main_spread_ids = this._issue_data[issue_id]
                .map((spread) => {
                    if (spread.type === "level") {
                        hasSubNavigation = true;
                        if (spread.show_close === true) {
                            this._close_button.push(+spread.id);
                        }
                        return +spread.id;
                    }
                    //flatten out the children so they are main_spreads to
                    else if (spread.type === "linear" && !spread.jumped) {
                        return [+spread.id, spread.children.map((spread) => +spread.id)];
                    }
                    //if no children just normal return
                    else {
                        return +spread.id;
                    }
                })
                .filter(Boolean)
                .flat(2);

            //We need to parse the spreads that are children but need to be on the top level because navigation type is linear
            this._issue_data[issue_id].forEach((item) => {
                if (item.type === "linear") {
                    if (!item.parsed) {
                        item.children.map((i) => {
                            return (i.jumped = true);
                        });
                        item.parsed = true;
                    }
                }
            });

            if (this._main_spread_ids.length === 0 || !hasSubNavigation) {
                this._main_spread_ids = false;
            }

            return this._main_spread_ids;
        } catch (error) {
            console.error("MAGLR ERROR: [createMainSpreadNavigationList]", error);
        }
    }

    getSubCloseButtonEnabled(issueId, spreadId) {
        if (this._close_button.length > 0) {
            if (!this.isMainSpread(issueId, spreadId)) {
                let spread_id = this.getMainSpreadBySpreadId(issueId, spreadId).id;
                if (this._close_button.indexOf(spread_id) > -1) {
                    return spread_id;
                }
            }
            return "close";
        }
        return null;
    }

    getMainSpreadBySpreadId(issueId, spreadId) {
        return this.findSpreadInIssueData(spreadId, this._issue_data[issueId], true);
    }

    getMainSpreadIndexBySpreadId(issueId, spreadId) {
        return this._issue_data[issueId]?.indexOf(this.getMainSpreadBySpreadId(issueId, spreadId));
    }

    getMainSpreadIdByIndex(issueId, index) {
        return this._issue_data[issueId]?.[index]?.id;
    }

    findMainSpreadIdOfSubSpread(issue_id, spread_id) {
        return parseInt(this.findSpreadInIssueData(spread_id, this._issue_data[issue_id], true)?.id, 10) || false;
    }

    findSpreadInIssueData(spread_id, issue_data, topLevel) {
        for (let i = 0; i < issue_data.length; i++) {
            if (parseInt(issue_data[i].id, 10) === spread_id) {
                return issue_data[i];
            }

            if (issue_data[i].children && issue_data[i].children.length > 0) {
                let found = this.findSpreadInIssueData(spread_id, issue_data[i].children, topLevel);
                if (found) {
                    if (topLevel) {
                        return issue_data[i];
                    } else {
                        return found;
                    }
                }
            }
        }
    }

    getMainSpreadsCount(issue_id) {
        return (
            this._main_spread_ids?.length ||
            this._issues[issue_id]?.js_spreads?.length ||
            this._issues[issue_id].spreads.length
        );
    }

    getMainSpreadsTopLevel(issue_id) {
        return this._issue_data[issue_id];
    }

    getOrderedSpreads(issue_id) {
        return this.filterAndOrderSpreads(issue_id).map((s) => s.spread_id);
    }

    /**
     * Create ordered spreads ready for rendering sidebar menu
     * @param issue_id
     * @param spreads
     * @returns {*}
     */
    filterAndOrderSpreads(issue_id, spreads = undefined) {
        if (this._ordered_spreads[issue_id]) {
            return this._ordered_spreads[issue_id];
        }

        if (this.hasMainSpreadNavigation(issue_id)) {
            //create this._main_spread_ids
            this.createMainSpreadNavigationList(issue_id);
        }

        if (this._ordered_spreads[issue_id] !== undefined) {
            return this._ordered_spreads[issue_id];
        }

        let output_spreads = [];
        if (Utils.isEmpty(spreads)) {
            spreads = this._getSpreadsByIssueId(issue_id);
        }

        if (Utils.isEmpty(spreads[0])) {
            console.warn("#1-2016 deprecated flow please publish the magazine again!");
        }

        if (window._first && window._first.issue_id === issue_id) {
            this._spreadSkip(spreads);
            this._spreadShow(spreads);
            this._spreadRotate(spreads);
        }

        let index = 0,
            subindex = 0;
        for (let i in spreads) {
            if (spreads[i].join_active == "1") {
                let date = spreads[i].date_published;
                this.createUrlList(spreads[i]);
                if (!Utils.isEmpty(date)) {
                    spreads[i].timestamp = date;
                }

                //filtering base on issue_data list (only the main spreads will be shown)
                if (this._issue_data[issue_id]?.length > 0) {
                    //if spread is a sub spread don't show it
                    if (!this.isMainSpread(issue_id, spreads[i].spread_id)) {
                        spreads[i].hidden = true;
                        // spreads[i]['page_index'] = index+'.'+(++subindex)+' ';
                        spreads[i]["page_index"] = `${index}.${++subindex} `;
                    } else {
                        //we got a main spread
                        subindex = 0;
                        spreads[i]["page_index"] = ++index;
                    }
                } else {
                    spreads[i]["page_index"] = ++index;
                }

                output_spreads.push(spreads[i]);
            }
        }

        this._ordered_spreads[issue_id] = output_spreads;

        return this._ordered_spreads[issue_id];
    }

    _getSaveUrlGets(data) {
        if (!data) {
            return false;
        }
        if (data.indexOf("[") > -1) {
            return JSON.parse(data);
        } else {
            return data.split(",");
        }
    }

    /**
     * Delete the spreads that are given as skip
     * @param spreads
     * @return {boolean}
     * @private
     */
    _spreadSkip(spreads) {
        try {
            const skips = this._getSaveUrlGets(this._urlInjects("skip"));
            skips &&
                skips.forEach((skip) => {
                    let index = spreads.findIndex(
                        (spread) => parseInt(skip, 10) === spread.spread_id || skip === spread.reference_tag,
                    );
                    if (index > -1) {
                        this._skippedSpreads.push(spreads.splice(index, 1)[0]);
                    }
                });

            return true;
        } catch (e) {
            console.warn(e);
            return false;
        }
    }

    /**
     * Remove all other spreads that are not shown
     * @param spreads
     * @return {boolean}
     * @private
     */
    _spreadShow(spreads) {
        try {
            let spreadShow = this._getSaveUrlGets(this._urlInjects("show"));

            if (spreadShow) {
                spreadShow = spreadShow.map((entry) => parseInt(entry, 10) || entry); // cast spread_id to int and leave ref tags unharmed
                let filtered = spreads.filter(
                    (spread) => spreadShow.includes(spread.spread_id) || spreadShow.includes(spread.reference_tag),
                );

                if (filtered.length === 0) {
                    console.error(
                        "MAGLR ERROR: The show parameter is active and none of the spreads matched the filter.",
                    );
                }

                let length = spreads.length;
                for (length; length > 0; length--) {
                    if (!filtered.includes(spreads[length - 1])) {
                        this._skippedSpreads.push(spreads.splice(length - 1, 1)[0]);
                    }
                }
            }

            return true;
        } catch (e) {
            console.warn(e);
            return false;
        }
    }

    /**
     * Randomize the spreads that are given as rotated
     * @param spreads
     * @return {boolean}
     * @private
     */
    _spreadRotate(spreads) {
        try {
            let rotate = this._getSaveUrlGets(this._urlInjects("rotate"));
            this._spread_rotate = [];
            let shuffleIndexes = [];

            rotate &&
                rotate.forEach((rotate) => {
                    let index = spreads.findIndex(
                        (spread) => parseInt(rotate, 10) === spread.spread_id || rotate === spread.reference_tag,
                    );
                    if (index > -1) {
                        shuffleIndexes.push(index);
                        this._spread_rotate.push(spreads[index]);
                    }
                });

            let currentIndex = this._spread_rotate.length,
                temporaryValue,
                randomIndex;
            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = this._spread_rotate[currentIndex];
                this._spread_rotate[currentIndex] = this._spread_rotate[randomIndex];
                this._spread_rotate[randomIndex] = temporaryValue;
            }

            shuffleIndexes.forEach((index) => {
                spreads[index] = this._spread_rotate.pop();
            });

            return true;
        } catch (e) {
            console.warn(e);
            return false;
        }
    }
    /**
     * Given url_inject that can be pushed to the spreads inside and
     * also have impact on the spread order / visibility of spreads ( rotate / skip )
     * @param search
     * @returns {*}
     * @private
     */
    _urlInjects(search) {
        return window.interface_settings.url_injects?.[search] ?? false;
    }

    createCompleteUrlList() {
        for (let issue in this.issues) {
            let spreads = this.issues[issue].js_spreads || this.issues[issue].spreads;
            spreads.forEach((spread) => this.createUrlList(spread));
        }
    }

    filterRecentIssues() {
        let result = [];

        this.filterIssues(null, 1);
        for (let issue_id in this._filtered_issues) {
            if (result.length < 3) {
                result.push(this._filtered_issues[issue_id]);
                continue;
            }
            break;
        }
        return result;
    }

    getBreadCrumb(issueId, spreadId) {
        let path = [];

        if (window.interface_settings?.settings?.overview_enabled) {
            path.push({
                url: "/",
                title: "overview",
            });
        }

        if (issueId) {
            //add issue to path
            path.push({
                url: this.issues[issueId].url,
                title: this.issues[issueId].issue_title,
            });

            if (spreadId) {
                //check if subspread, if get parent and add
                if (!this.isMainSpread(issueId, spreadId)) {
                    let mainSpread = this.getMainSpreadBySpreadId(issueId, spreadId);
                    path.push({
                        url: mainSpread.url,
                        title: mainSpread.spread_title,
                    });
                }

                //add current spread to path
                let spread = this.getSpreadById(issueId, spreadId);
                path.push({
                    url: spread.url,
                    title: spread.spread_title,
                });
            }
        }

        if (path.length > 0) {
            path[path.length - 1].current = true;
        }

        return path;
    }
}
